import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadForm from "./component";
import { setStep, setData, activateLastStep, setFlowName } from "./actions";
import { setProgressBarData, setVisitedState } from "../lead-progress-bar/actions";

const mapStateToProps = ({
    leadData,
    leadProgressBar: { data: progressBarData }
}) => ({
    leadData,
    progressBarData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setStepConnect: setStep,
    setDataConnect: setData,
    activateLastStepConnect: activateLastStep,
    setProgressBarDataConnect: setProgressBarData,
    setFlowNameConnect: setFlowName,
    setVisitedStateConnect: setVisitedState
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadForm);
